import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import {validateEmpty} from '../../../../global/custom-validate';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {Subject} from 'rxjs';
import {DatePipe} from '@angular/common';
import {GroupSelectComponent} from '../../group/groupselect.component';
import {CommandUtil} from '../../../../global/commandutil';
import {VanBanDen} from '../../../../models/vanbanden/vanbanden';
import {VanBanDenService} from '../../../../service/vanbanden/service-vanbanden';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {FormatService} from '../../../../service/format/service-format';
@Component({
  templateUrl: './butphe.component.html'

})
export class ButPheVanBanDenComponent implements OnInit, AfterViewInit {

  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public id: number=0;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public submitValidate = false;
  public dateThoiHan: Date;
  public staffSingerList: Object[] =[];
  public selectedSingerList: Object[]=[];
  public  onClose: Subject<boolean>;
  public vanBanDenItem: VanBanDen=new VanBanDen();
  constructor(
    public formBuilder: FormBuilder,
    public toastr: ToastrService,
    public bsModalService: BsModalService,
    public datepipe: DatePipe,
    public _bsModalRef: BsModalRef,
    public commandUtils: CommandUtil,
    public vanBanDenService: VanBanDenService,
    public formatService: FormatService

  ) {
  }
  ngAfterViewInit() {

  }

  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
  }
  public edit(id: number) {
    this.id= id;
    this.isEdit =(id!=0)? true: false;
    this.vanBanDenService.getById(id).subscribe(data => {
      this.vanBanDenItem = data;
      this.frmGroup.patchValue({butPhe : data.noiDungXL});
    });


  }

  ngOnInit(): void {
    this.onClose = new Subject();
    this.frmGroup = new FormGroup({
      butPhe: new FormControl(),
    });
    this.frmGroup = this.formBuilder.group({
      butPhe: ['' , Validators.compose([validateEmpty]) ]
    });
  }

  get f() { return this.frmGroup.controls; }
  public actionXuLy()
  {

    this.vanBanDenService.butPhe(this.id,  (this.selectedSingerList.length > 0 ? Number(this.selectedSingerList[0]) : 0), this.frmGroup.value.butPhe ===''?'  ': this.frmGroup.value.butPhe
    ).subscribe(
      {
        next: (data) => {
          this.toastr.success(language.butphe_success, language.message);
          Sessioncommand.notification = false;
          Sessioncommand.vanBanDenStatus = 0;
          this.onSave();
        },
        error: error => {
          Sessioncommand.notification = true;
          Sessioncommand.vanBanDenStatus = 0;
          this.toastr.error(language.error, language.message);
        }
      });


  }
  public onSubmit()
  {
    this.submitValidate = true;

    if(this.frmGroup.invalid)
      return;
    this.actionXuLy();


  }
  public onSave(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }
  public showSinger()
  {
    const modalEdit = this.bsModalService.show(GroupSelectComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<GroupSelectComponent>modalEdit.content).showDonVi(
      this.staffSingerList
    );
    (<GroupSelectComponent>modalEdit.content).selectStaffs.subscribe(result => {
      if(result != null && result.length >= 1)
      {
        if(this.staffSingerList.some(e => e["id"] === result[0].id)==false) {
          this.staffSingerList= [...this.staffSingerList, {id: result[0].id, fullName: result[0].fullName}];
          this.selectedSingerList= [...this.selectedSingerList, result[0].id];
        }
      }
    });
  }
}

